<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>
            <BTabs :active-tab.sync="active_tab" >
              <CTab  :title="$t('accounting')" v-if="get_access('setting_accounts')">
                <AccountingReport/>
              </CTab>
              <CTab  :title="$t('sidebars.inventory')">
                <InventoryReport/>
              </CTab>
              <CTab  :title="$t('sells')">
                <SaleReport/>
              </CTab>
              <CTab  :title="$t('buy')">
                <BuyReport/>
              </CTab>
              <CTab v-if="get_access('delivery')"  :title="$t('sidebars.delivery')">
                <DeliveryReport/>
              </CTab>
<!--              <CTab v-if="get_access('default_accounts')" :title="$t('periodReport')">-->
<!--                <PeriodReport/>-->
<!--              </CTab>-->
              <BTab :title="$t('PeriodReportAmountCirc')" v-if="get_access('period_report')">
                <PeriodReportAmountCirculation/>
              </BTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";

var items = [];
import AccountingReport from "./AccountingReport";
import BuyReport from "./BuyReport";
import InventoryReport from "./InventoryReport";
import SaleReport from "./SaleReport";
import DeliveryReport from "./DeliveryReport";
import PeriodReport from "./PeriodReport";
import BTab from "../../tabs/BTab.vue";
import PeriodReportAmountCirculation from "../accounting/Reports/PeriodReportAmountCirculation.vue";
export default {
  name: 'Login',
  components: {
    PeriodReportAmountCirculation, BTab,
    BTabs,
    BuyReport,
    InventoryReport,
    SaleReport,
    DeliveryReport,
    AccountingReport,
    PeriodReport
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,


      active_tab:parseInt(localStorage.getItem("report_active_tab",0)),

      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];


  }, watch: {

    'active_tab': function () {
      localStorage.setItem("report_active_tab",this.active_tab)
    }
  },
  methods: {

  }
}

</script>
